export default __webpack_public_path__ + "static/media/AnimalMondey02_04.bc3eb4ef.png";